// export function isValidUsername(str: string) {
//   const validMap = ['weAdmin', 'lipu', 'chongqing'];
//   return validMap.indexOf(str.trim()) >= 0;
// }

export function isExternal(path: string) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

export function validateLowerCase(str: string) {
  const reg = /^[a-z]+$/;
  return reg.test(str);
}

export function validateUpperCase(str: string) {
  const reg = /^[A-Z]+$/;
  return reg.test(str);
}

export function validatUserName(str: string) {
  const reg = /^[a-zA-z]\w{3,15}$/;
  return reg.test(str);
}

export function validatePhoneNumber(str: string) {
  const reg = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
  return reg.test(str)
}
